import React from 'react'
import EditableText from 'blocks.simple/editableText/editableText'
import Button from 'blocks.simple/button/button'
import CustomListHeader, { ICustomListHeaderProps } from '../../__header/customList__header'
import CatalogSelectContent from 'blocks.app/catalog/_select/_content/catalog_select_content'
import helpers from 'core/helpers'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import grid from 'blocks.simple/grid/grid.jcss'
import { cn } from 'ethcss'
import listStyles, { mediaPreviewItemStyles } from '../../__content/customList__content.jcss'

export default {
    getMethod: 'getBurgersCatalogByType',
    onCatalogUpdatedMethod: 'burgersCatalogUpdated',
    emptyDescription: () => translate('noItemsDescription'),
    emptyIcon: 'not_allow',
    settingsPrefixes: 'combo',
    getItemModel: (
        dataItem: { __view: { selected: boolean }; source: { __view: { selected: boolean } } },
        getSelected: (item: object) => any
    ) => {
        const item = { ...dataItem }

        if (item.source && !item.source.__view) {
            item.source.__view = {
                selected: getSelected(item),
            }
        }
        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    isEqual: (firstItem: { id: number }, secondItem: { id: number }) => firstItem.id === secondItem.id,
    ...helpers.createListeners({
        category: null,
        type: 'combo',
        onCreate: 'burgersProductCreated',
        onUpdate: 'burgersProductUpdated',
        onDelete: 'burgersProductDeleted',
    }),
    fields: () => [
        { id: 'source', name: translate('content') },
        { id: 'title', name: translate('name') },
        { id: 'fileType', name: translate('contentType') },
    ],
    init(callback: any) {
        // @ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    headerFilters: (p_: ICustomListHeaderProps) => (
        <CustomListHeader
            {...p_}
            onAdd={() => p_.onAddFakeLine({ title: '', source: null })}
            title={translate('comboCatalog')}
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem: { id: number }) => selectedItem.id)
                if (id.length > 0) {
                    api.send('deleteBurgersProduct', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
        />
    ),
    list: {
        title: (
            p_: { id: number; title: string },
            active: boolean,
            listProps: {
                source: { id: number }
                fakeLine: object
                onAddFakeLine: (value?: {}) => void
            }
        ) => (
            <EditableText
                id={p_.id}
                text={p_.title}
                onChange={(title: string) => {
                    listProps.onAddFakeLine({ ...listProps.fakeLine, title })
                }}
                onUpdate={(title, cb) => {
                    api.send('updateBurgersProduct', {
                        catalogType: 'combo',
                        webAppSourceId: listProps.source.id,
                        id: p_.id,
                        title,
                    }).then(cb)
                }}
            />
        ),
        fileType: (
            p_: { source: { fileType: string }; id: number },
            active: boolean,
            listProps: {
                source: { id: number }
                fakeLine: { title: string; source: { id: number } }
                onAddFakeLine: (value?: {}) => void
            }
        ) => {
            let contentType = ''

            if (p_.source) {
                contentType = translate(p_.source.fileType)
            }

            return (
                <div className={cn(grid.fullWidth, { [grid.row]: !p_.id })}>
                    <div className={cn({ [grid.fullWidth]: p_.id, [grid.space]: !p_.id })}>
                        <span style={{ textTransform: 'lowercase' }}>{contentType}</span>
                    </div>
                    {!p_.id && (
                        <Button
                            className={cn(grid.ml_micro, grid.mr_mini)}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                            onClick={function () {
                                listProps.onAddFakeLine()
                            }}
                        >
                            {translate('cancel')}
                        </Button>
                    )}
                    {!p_.id && (
                        <Button
                            mod={'fill'}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                            onClick={function () {
                                api.send('createBurgersProduct', {
                                    catalogType: 'combo',
                                    sourceId: listProps.fakeLine.source.id,
                                    webAppSourceId: listProps.source.id,
                                    ...listProps.fakeLine,
                                })
                            }}
                            disabled={!listProps.fakeLine.title || !listProps.fakeLine.source}
                        >
                            {translate('save')}
                        </Button>
                    )}
                </div>
            )
        },
        source: (
            p_: { id: number; source: object },
            active: boolean,
            listProps: {
                source: { id: number }
                fakeLine: object
                onAddFakeLine: (value?: {}) => void
            }
        ) => (
            <div className={cn(grid.fullWidth, grid.colCenter)}>
                <div className={p_.source ? listStyles.mediaPreviewFilled : undefined}>
                    <CatalogSelectContent
                        type={'media'}
                        selectedInfo={p_.source}
                        selectedItemStyles={p_.source ? mediaPreviewItemStyles : undefined}
                        onSelect={(selectedMedia: { id: number }) => {
                            if (p_.id) {
                                api.send('updateBurgersProduct', {
                                    catalogType: 'combo',
                                    webAppSourceId: listProps.source.id,
                                    id: p_.id,
                                    sourceId: selectedMedia.id,
                                })
                            } else {
                                listProps.onAddFakeLine({ ...listProps.fakeLine, source: selectedMedia })
                            }
                        }}
                    />
                </div>
            </div>
        ),
    },
    draggable: true,
    onDeleteListItem: (listItem: { id: number }) => {
        api.send('deleteBurgersProduct', { id: listItem.id })
    },
    fixedColWidth: true,
}
